import React from 'react'

import Badge from 'components/common/Badge'
import Tooltip2 from 'components/common/Tooltip2.0'
import { CHAT } from 'constants/socket'

import { ChatIcon, Wrapper } from './styles'

const chatIcon = {
    src: '/assets/revamp/chat.new.svg',
    alt: 'chat-icon',
}

const ChatButton = ({ isChatOpen, toggleChat, unreadCount }) => {
    const tooltipContent = isChatOpen ? '' : CHAT

    return (
        <Tooltip2 content={tooltipContent}>
            <Wrapper onClick={toggleChat}>
                <ChatIcon {...chatIcon} />
                {unreadCount ? <Badge count={unreadCount} /> : null}
            </Wrapper>
        </Tooltip2>
    )
}

export default ChatButton
